import { isNumber, isString } from 'lodash-es';

import { validateCSSSize } from './validate-css-size.js';

const PX_UNIT = 'px';
const PX_PATTERN = /^(\d+(?:\.\d+)?)px$/;

/**
 * Coerces a string or numeric value into a valid CSS size length value (width, height, etc.)
 * If the value is numeric it will assume that is expressed in pixels
 * @param value - the value to coerce.
 *
 * @internal
 *
 */
export function coerceSizeValue(value?: string | number): string | undefined {
  if (isNumber(value)) {
    return `${value}${PX_UNIT}`;
  }

  if (isString(value)) {
    return validateCSSSize(value);
  }

  return undefined;
}

/**
 * Coerces a string or numeric size value to a pixel number.
 * Returns `undefined` when the value is a non-pixel string (e.g. `'100%'`, `'vh'`, `'rem'`).
 *
 * @internal
 */
export function coerceSizeValueToPixels(
  value: number | string | undefined,
): number | undefined {
  if (isNumber(value)) {
    return value;
  }
  if (isString(value)) {
    const valid = validateCSSSize(value);
    if (valid) {
      const match = PX_PATTERN.exec(valid);
      if (match) {
        return Number(match[1]);
      }
    }
  }

  return undefined;
}
